import { NavLink } from 'react-router';
import {
  Building2,
  CalendarClock,
  CalendarX2,
  FileCode2,
  FileSignature,
  Fingerprint,
  Mail,
  Menu,
} from 'lucide-react';
import type { LucideIcon } from 'lucide-react';

interface Pestana {
  a: string;
  etiqueta: string;
  descripcion: string;
  icono: LucideIcon;
}

const PESTANAS: Pestana[] = [
  {
    a: '/configuracion',
    etiqueta: 'Empresa',
    descripcion: 'Datos del emisor y SRI',
    icono: Building2,
  },
  {
    a: '/configuracion/emision',
    etiqueta: 'Emisión',
    descripcion: 'Programación de cobros',
    icono: CalendarClock,
  },
  {
    a: '/configuracion/feriados',
    etiqueta: 'Feriados',
    descripcion: 'Días no hábiles',
    icono: CalendarX2,
  },
  {
    a: '/configuracion/comprobantes',
    etiqueta: 'Comprobantes',
    descripcion: 'Lo que viaja en el XML',
    icono: FileCode2,
  },
  {
    a: '/configuracion/documentos',
    etiqueta: 'Documentos',
    descripcion: 'Papel corporativo y firmas',
    icono: FileSignature,
  },
  {
    a: '/configuracion/correo',
    etiqueta: 'Correo',
    descripcion: 'Servidor SMTP',
    icono: Mail,
  },
  {
    a: '/configuracion/dinardap',
    etiqueta: 'Dinardap',
    descripcion: 'Consulta de identidad',
    icono: Fingerprint,
  },
  { a: '/menu', etiqueta: 'Menú', descripcion: 'Organizar el menú lateral', icono: Menu },
];

export function PestanasDeConfiguracion() {
  return (
    <nav
      aria-label="Áreas de configuración"
      className="mb-6 flex gap-2 overflow-x-auto rounded-xl border border-armazon-100 bg-armazon-50 p-1.5"
    >
      {PESTANAS.map(({ a, etiqueta, descripcion, icono: Icono }) => (
        <NavLink
          key={a}
          to={a}

          end={a === '/configuracion'}
          className={({ isActive }) =>
            [
              'flex flex-1 shrink-0 items-center justify-center gap-2.5 rounded-lg px-4 py-2.5 text-sm font-medium transition-colors',
              isActive
                ? 'border border-armazon-200 bg-white text-armazon-900 shadow-sm'
                : 'text-armazon-500 hover:bg-white/60 hover:text-armazon-700',
            ].join(' ')
          }
        >
          {({ isActive }) => (
            <>
              <Icono
                className={`size-4 shrink-0 ${isActive ? 'text-marca-600' : ''}`}
                aria-hidden
              />
              <span className="hidden text-left sm:block">
                <span className="block leading-tight">{etiqueta}</span>
                <span
                  className={`block text-[10px] font-normal uppercase leading-tight ${
                    isActive ? 'text-armazon-500' : 'text-armazon-400'
                  }`}
                >
                  {descripcion}
                </span>
              </span>
              <span className="sm:hidden">{etiqueta}</span>
            </>
          )}
        </NavLink>
      ))}
    </nav>
  );
}
